import { oids } from "../lib/oids";
import { call } from "../lib/jsonrpc";

export const networkDeviceCiscoSpectrumEntryStop = (id, entryId) => {
  return call('networkDeviceSnmpSet', { id, oid: oids.ccsSpectrumRequestStatus + '.' + entryId, value: 1, type: 2 });
}

export default networkDeviceCiscoSpectrumEntryStop;